<!-- TODO same: src/components/items/NoDataSelectVListItem.vue -->
<template>
  <div :class="$style.tableEmptyText" data-testid="tableEmptyText">
    <p :class="$style.p">
      <slot>No results found. Try changing searching request</slot>
    </p>
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';

.tableEmptyText {
  padding-top: 10px;
  padding-bottom: 10px;
  color: colors.$color-text-tertiary;
  text-align: center;
}
  .p {
    margin: 1.5rem 0;
  }
</style>
